module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_vm._v("Cooking and Prep Terms")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most of the recipes in this book have self-explanatory cooking instructions, but in case you want to double-check that you're doing something right or refer to what a term means, we've included this handy guide.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Baking ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cooking foods with dry heat in an oven. Always preheat the oven at least 10 minutes before baking foods; low temperatures can alter the results of recipes. When baking more than one item at a time (say, two trays of cookies), leave space between the items so that the hot air circulates and cooks the food evenly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blanching ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dipping fruits or vegetables into rapidly boiling water for a few seconds to a couple of minutes, then dunking them into cold water immediately afterward. Blanching is used to loosen peach and tomato skins; lightly cook vegetables, such as broccoli and asparagus, to set their vibrant colors; and get fresh produce ready for freezing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Braising ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Foods are sautéed in a little oil, then simmered in liquid to produce rich, velvety dishes with loads of flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Broiling ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cooking with high heat from above. The secret to broiling success is to preheat the broiler well and have the oven rack in the topmost position. Then keep a watchful eye to make sure foods don't burn.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chiffonading ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Slicing leafy greens into thin strips.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chopping ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cutting food into bite-size or smaller pieces with downward movements (chops) of a knife.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cubing ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cutting fruits or vegetables into cubes or cubelike shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dicing ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cutting fruits or vegetables into small (¼-inch or smaller) cubes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Deep-Frying  ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Not a technique we use often, but still a good one to know. Deep-frying is done in a pot that is filled one-third to half full with oil, then heated to 375°F. Food is lowered into the oil in small batches (to keep the temperature from dropping) and cooked until golden brown. Draining deep-fried foods on a paper-towel-lined plate keeps them from getting soggy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Deglazing ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Adding a liquid—wine, broth, water, alcohol—to ingredients in a skillet or saucepan to loosen any bits (which happen to hold lots of flavor) stuck to the bottom of the pan, bringing the flavors together.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Folding ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gently incorporating one mixture into another using a spatula or wooden spoon.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Julienning ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cutting fruits or vegetables into thin matchsticks with a knife or mandoline.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mincing ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cutting into tiny pieces. This term is most often used for garlic and ginger, and occasionally onions or shallots.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Poaching ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cooking foods in simmering, not boiling, water.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Puréeing ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Blending ingredients into a smooth, thick paste. Food processors, blenders, and hand blenders can be used to purée.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Roasting ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Like baking, roasting uses dry oven heat to cook foods. The oven temperature is generally high because the idea is for foods to brown, crisp up, and caramelize on the outside.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sautéing ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cooking foods in a small amount of oil over medium to medium-high heat. \"Sauté\" comes from the French word meaning \"to jump\"; you want to make the food jump in the pan—so shake or stir it often.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Simmering ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cooking a liquid over medium to medium-low heat to allow it to bubble but not be at a rolling boil.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Steaming ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cooking foods using steam from boiling water in the bottom of a covered pot or saucepan. Foods are placed in a steamer or steamer basket to prevent them from coming in direct contact with the boiling water.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Stir-Frying ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Stir-frying is a stove-top technique for cooking foods in a small amount of oil or fat using a wok or skillet.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac8c928","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780470547885f04.vue
// module id = 72
// module chunks = 0